/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-anonymous-default-export */

import { useEffect, useState } from "react";

export default () => {
  const [viewport, setViewport] = useState(global?.window && window.innerWidth);

  useEffect(() => {
    const handleResize = () => setViewport(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return viewport;
};
